module.exports = __webpack_public_path__ + "img/2021_0.8e67fe23.webp";